import { Injectable } from '@angular/core'
import { WindowService } from './window.service'

@Injectable({
  providedIn: 'root'
})
export class RedirectService {
  private _window: Window

  constructor(
    private _windowService: WindowService
  ) {
    this._window = _windowService.window
  }

  public redirectTo(url: string) {
    this._window.location.href = url
  }
}
